import store from '@/store';
import DeviceType from '@/helpers/DeviceType';
import Tizen from './Tizen';
import LG from './LG';
//import Orsay from './Orsay';
import Orsay from './Tizen';
import RPI from './RPI';

export const SERVICE_TYPE = {
  TV: 'tv',
  RADIO: 'radio',
  INFO: 'info',
  UNKNOWN: 'unknown',
};

export const DVB_TYPE = {
  C: 'c',
  S: 's',
  T: 't',
  IP: '',
};

export const TV_STATUS = {
  LOADED: 'loaded',
  LOADING: 'loading',
  STARTED: 'started',
  READY: 'ready',
  CLOSED: 'closed',
};

export default class TV {
  static identifyChannel(channel) {
    if (channel.serviceType === SERVICE_TYPE.RADIO) {
      return SERVICE_TYPE.RADIO;
    }
    if (channel.serviceType === SERVICE_TYPE.TV) {
      return SERVICE_TYPE.TV;
    }
    if (channel.serviceType === SERVICE_TYPE.INFO) {
      return SERVICE_TYPE.INFO;
    }
    return SERVICE_TYPE.UNKNOWN;
  }

  static setChannel(channel, isNew) {
    const type = this.identifyChannel(channel);
    if (type === SERVICE_TYPE.UNKNOWN) {
      store.dispatch('notification/error', {
        title: 'Service Type not supported',
      });
      return;
    }

    if (DeviceType.isRPI) {
      RPI.setChannel(channel, type, isNew);
    } else if (DeviceType.isTizen) {
      Tizen.setChannel(channel, type, isNew);
    } else if (DeviceType.isLG) {
      LG.setChannel(channel, type, isNew);
    } else if (DeviceType.isOrsay) {
      Orsay.setChannel(channel, type, isNew);
    } else {
      store.dispatch('tv/setStatus', TV_STATUS.LOADED);
    }
  }

  static createPlayer(channel) {
    this.setChannel(channel);
  }

  // Stoppt Tuner und Media-Playback OHNE Channel-Objekt.
  //
  // Fuer Seiten, die kein Video zeigen (z.B. Cast): laeuft der Tuner weiter, ist
  // sein Ton im Hintergrund zu hoeren - entweder der zuletzt gespielte Kanal
  // oder, nachdem ein App-Start fehlgeschlagen ist, ein Kanal aus der
  // geraeteeigenen Senderliste.
  //
  // Anders als removePlayer() braucht das keinen Kanal: removePlayer liest
  // channel.dvb_type und wirft, wenn gar kein Kanal aktiv ist (z.B. direkt nach
  // dem App-Start oder wenn getActiveChannel noch leer ist).
  // Der Grund steht im Log, weil dieser Aufruf mehr abraeumt als seinen Namen:
  // auf LG setzt clearChannel neben stopCurrentChannel auch hcap.Media.shutDown
  // ab (media_shutdown). Ob das die Cast-/DIAL-Sichtbarkeit des TV mitnimmt, ist
  // NICHT vermessen - es steht aber im Verdacht, und seit der Tuner zentral im
  // Router gestoppt wird, faellt der Aufruf auf jeder Seite ohne Live-Bild an.
  // Mit dem Grund laesst sich im Log nachvollziehen, was unmittelbar vor einem
  // "kein Geraet zum Verbinden" passiert ist.
  static stopPlayback(reason) {
    console.log('[TV] stopPlayback (' + (reason || 'ohne Angabe') + ')');
    try {
      if (DeviceType.isTizen) Tizen.clearChannel();
      if (DeviceType.isLG) LG.clearChannel();
      if (DeviceType.isOrsay) Orsay.clearChannel();
    } catch (e) {
      console.log('TV.stopPlayback error', e);
    }
    return Promise.resolve();
  }

  // Internen Samsung-Tuner stumm schalten.
  //
  // InputSource/SourceSelect schalten beim Verlassen auf die Quelle TV 1
  // zurueck - und die Firmware spielt dann den zuletzt am Geraet gesehenen
  // Sender ab, hinter der App hoerbar. clearChannelDVB stimmt (wie beim
  // Verlassen des TV-Players) auf einen leeren Kanal ab und blendet das
  // Fenster aus.
  static silenceTuner(reason) {
    console.log('[TV] silenceTuner (' + (reason || 'ohne Angabe') + ')');
    try {
      if (DeviceType.isTizen) Tizen.clearChannelDVB();
    } catch (e) {
      console.log('TV.silenceTuner error', e);
    }
    return Promise.resolve();
  }

  // ---- Live-Vorschau -------------------------------------------------------
  //
  // Startet den Kanal und verkleinert die Videoflaeche auf das uebergebene
  // Rechteck (Prozent der Bildflaeche).
  //
  // WICHTIG: Auf LG ist die Videogroesse globaler Geraetezustand und bleibt nach
  // dem Verlassen der Seite bestehen. Zu JEDEM startPreview() muss deshalb ein
  // stopPreview() laufen - auch bei Fehlern und beim Verlassen der Seite -, sonst
  // startet der TV-Player anschliessend mit verkleinertem Bild.
  static startPreview(channel, rect) {
    if (!channel) return false;
    try {
      if (DeviceType.isTizen || DeviceType.isOrsay) {
        // Tizen: erst Groesse setzen, dann tunen - der Tune-Pfad wuerde das
        // Rechteck sonst wieder auf 100% ziehen.
        Tizen.setVideoRect(rect);
        Tizen.setChannel(channel, SERVICE_TYPE.TV, true);
        return true;
      }
      if (DeviceType.isLG) {
        // LG: erst tunen, dann verkleinern. Umgekehrt setzt der Tune-Pfad
        // (Media.startUp) die Flaeche wieder auf Vollbild.
        LG.setChannel(channel, SERVICE_TYPE.TV, true);
        LG.setVideoRect(rect);
        return true;
      }
    } catch (e) {
      console.log('TV.startPreview error', e);
      // Auch im Fehlerfall aufraeumen, damit keine verkleinerte Flaeche bleibt.
      TV.stopPreview();
    }
    return false;
  }

  // Beendet die Vorschau und setzt die Videoflaeche zurueck auf Vollbild.
  // Bewusst tolerant: darf jederzeit und mehrfach aufgerufen werden.
  static stopPreview() {
    try {
      if (DeviceType.isTizen || DeviceType.isOrsay) {
        Tizen.clearChannel();
        Tizen.resetVideoRect();
      }
      if (DeviceType.isLG) {
        LG.clearChannel();
        LG.resetVideoRect();
      }
    } catch (e) {
      console.log('TV.stopPreview error', e);
    }
    return Promise.resolve();
  }

  static removePlayer(channel) {
    if (DeviceType.isTizen) {
      Tizen.removePlayer(channel);
    }
    if (DeviceType.isLG) {
      LG.removePlayer(channel);
    }
    if (DeviceType.isOrsay) {
      Orsay.removePlayer(channel);
    }
    if (DeviceType.isRPI) {
      RPI.removePlayer(channel);
    }
  }

  static turnOff() {
    if (DeviceType.isTizen) {
      Tizen.turnOff();
    }
    if (DeviceType.isLG) {
      LG.turnOff();
    }
    if (DeviceType.isOrsay) {
      Orsay.turnOff();
    }
  }
  static turnOn() {
    if (DeviceType.isTizen) {
      Tizen.turnOn();
    }
    if (DeviceType.isLG) {
      LG.turnOn();
    }
    if (DeviceType.isOrsay) {
      Orsay.turnOn();
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/TV/index.js